import { FC, HTMLAttributes } from 'react';
import cn from 'classnames';
import { toRecord } from 'base/utils/data';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';

export type PriceDirectionType = 'horizontal' | 'break-horizontal' | 'vertical';

export type IProductPrice = {
    className?: string;
    product: any;
    direction: PriceDirectionType
}


const ProductPrice: FC<IProductPrice> = props => {
    const {
        className,
        product: {
            shopPrice,
            shopPriceExchangeDisplay,
            marketPriceExchangeDisplay,
            alterMarketPriceExchangeDisplay
        },
        direction = 'horizontal'
    } = props;

    const { t } = useTrans();

    const hasMarketPrice = shopPriceExchangeDisplay !== marketPriceExchangeDisplay;

    return (
        <div className={cn(
            className,
            styles.prices,
            styles[direction],
            direction,
            'g-prices',
        )}>
            <strong className={cn('g-shop-price', { 'g-highlight': hasMarketPrice })}>
                {Number(shopPrice) === 0 ? t('web_price_free') : shopPriceExchangeDisplay}
            </strong>

            {!!alterMarketPriceExchangeDisplay &&
                <span className="g-alter-price">{alterMarketPriceExchangeDisplay}</span>}

            {hasMarketPrice && (<del className="g-market-price">{marketPriceExchangeDisplay}</del>)}
        </div>
    )
};

export default ProductPrice